import PropTypes from 'prop-types';
import React from 'react';

import { useGetStoreInfo } from '../../globals';
import { getFormattedCurrency } from '../../utils/currencyUtils';

export function MultipleCurrencyText({ value, isForeignTender, foreignCurrency }) {
  const { currency, locale } = useGetStoreInfo();
  const formattedCurrency = getFormattedCurrency(
    locale,
    isForeignTender ? foreignCurrency : currency,
    value,
  );
  return <span>{formattedCurrency}</span>;
}

export function GetMultipleCurrencyText(value) {
  const { currency, locale } = useGetStoreInfo();
  const formattedCurrency = getFormattedCurrency(locale, currency, value);
  return formattedCurrency;
}

MultipleCurrencyText.defaultProps = {
  isForeignTender: false,
  foreignCurrency: '',
};

MultipleCurrencyText.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  isForeignTender: PropTypes.bool,
  foreignCurrency: PropTypes.string,
};
